module.exports = __webpack_public_path__ + "img/active4.2a6724f0.png";